export default {
  defaultMfaDevice: (state) => {
    return state.mfaDevices.find((device) => device.name === "default");
  },
};
